import IndexView from '@/views/IndexView.vue'
import HomePage from '@/components/pages/HomePage.vue'

const langNavigator = navigator.language.replace(/-.+$/, '')

const routes = [
  {
    path: '/:lang([a-z]{2})?/:doc([^/]+)?/:version(\\d+\\.\\d+)?',
    component: IndexView,
    children: [
      {
        name: 'home',
        path: '',
        component: HomePage,
        meta: {
          langDefault: langNavigator || process.env.VUE_APP_I18N_LOCALE,
          docDefault: 'privacy'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: {
      name: 'home'
    }
  }
]

export default routes
